import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { withRouter } from "react-router-dom";
import { Container } from "reactstrap";
import EmployeesReportSearch from "./employeesReportSearch";

interface Props {
  userContext: { clubSessionId: any };
}

interface State {}

class EmployeesReport extends React.Component<Props, State> {
  render() {
    return (
      <Container className="p-0 mt-3">
        <EmployeesReportSearch userContext={this.props.userContext} />
      </Container>
    );
  }
}

export default withRouter(withStyles()(EmployeesReport));
